module.exports = __webpack_public_path__ + "static/media/cs.4c7c588a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cs.png
// module id = 111
// module chunks = 0